import { TabConfig } from 'todistukset-ui/src/vtj/components/tab-navigation/tab-navigation.types'
import { Tabs } from 'todistukset-ui/src/vtj/components/tab-navigation/todistus-tabs.enum'

export const tabConfig: TabConfig = {
  [Tabs.CONTENT]: {
    path: 'etusivu',
    labelKey: 'navigationTabsTodistusOrderTitle',
  },
  [Tabs.INFO]: {
    path: 'lisatiedot',
    labelKey: 'navigationTabsFaqTitle',
  },
  [Tabs.MY_CERTIFICATES]: {
    path: 'omat-todistukset',
    labelKey: 'navigationTabsOrderedCertificatesTitle',
  },
}
